import React from "react";

type CheckBoxProps = {
  checked: boolean;
  setChecked: () => void;
  label: string;
};

export const Checkbox: React.FC<
  CheckBoxProps & React.ComponentProps<"input">
> = ({ checked, setChecked, label, ...props }) => {
  return (
    <div onClick={setChecked}>
      <input type="checkbox" checked={checked} className="cursor-pointer" />
      <label className="cursor-pointer select-none ml-2">{label}</label>
    </div>
  );
};
